import { apiClient } from "@/api";

export const NotificationApi = {
  /**
   * Получение количества уведомлений
   * @returns {Promise<Object>} - Данные о количестве уведомлений
   */
  async getNoticesCount() {
    return apiClient.get("/notices-count");
  },

  /**
   * Получение уведомлений
   * @param {Object} params - Параметры запроса
   * @returns {Promise<Array>} - Список уведомлений
   */
  async getNotifications(params = {}) {
    return apiClient.get("/notices", { params });
  },

  /**
   * Отметить уведомление как прочитанное
   * @param {Number} id - ID уведомления
   * @returns {Promise<Object>}
   */
  async markAsRead(id) {
    return apiClient.put(`/notices/${id}/read`);
  },

  /**
   * Отметить все уведомления как прочитанные
   * @returns {Promise<Object>}
   */
  async markAllAsRead() {
    return apiClient.put("/notices/read-all");
  },
};
